import React, { useState } from 'react'
import logo from '../Assets/Logo.png'
import img from '../Assets/Group 1000005970.png'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify';
function Footer() {

    const [email, setEmail] = useState("");

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubscribe = () => {
        if (validateEmail(email)) {
            toast.success("Newsletter Subscribed!");
            setEmail('')
        } else {
            toast.error("Please enter a valid email address.");
        }
    };

    return (
        <>
            <div className='footer'>
                <div className='top-footer'>
                    <div>
                        <img src={logo} />

                    </div>
                    <div className='SubscribeNewsletter'>
                        <h4>Subscribe Newsletter</h4>
                        <div className='subc-div'>
                            <input
                                placeholder='Enter Your Email'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <button onClick={handleSubscribe}>Subscribe</button>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <div className='bottom-footer'>
                    <ul>
                        Pages
                        <br />
                        <Link className='none' to='/'>

                            <li>Home</li>
                        </Link>
                        <Link className='none' to='/about'>

                            <li>About</li>
                        </Link>

                        <Link className='none' to='/destination'>

                            <li>Destination</li>
                        </Link>



                    </ul>
                    <ul>
                        Quick Links
                        <br />
                        <Link className='none' to='/contact'>

                            <li>Contact Us</li>
                        </Link>
                        <Link className='none' to='/faq'>

                            <li>FAQ</li>
                        </Link>
                        <Link className='none' to='/blog'>

                            <li>Blog</li>
                        </Link>

                        <Link className='none' to='/whyus'>

                            <li>Why Choose Us</li>
                        </Link>
                        <Link className='none' to='/lead'>

                            <li>lead</li>
                        </Link>


                    </ul>

                    <ul>
                        Contact
                        <br />

                        <li>
                            <div className='circle'><i class="bi bi-geo-alt-fill"></i></div>
                            55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, <br />Phuket 83000, Thailand</li>
                        <li>
                            <div className='circle'><i class="bi bi-telephone-fill"></i></div>
                            +66 930711160
                        </li>
                        <li>
                            <div className='circle'><i class="bi bi-envelope-fill"></i></div>
                            b2b@expleradmc.com</li>
                        <Link className='none2' to='https://b2b.explera.co.th/web/login'>
                            <li>

                                <div className='circle'><i class="bi bi-envelope-fill"></i></div>
                                OUR B2B PORTAL
                            </li>
                        </Link>
                        <Link className='none2' to='https://b2b.explera.co.th/web/signup?'>
                            <li>

                                <div className='circle'><i class="bi bi-envelope-fill"></i></div>
                                SIGN UP B2B PORTAL
                            </li>
                        </Link>

                    </ul>


                </div>
                <br />
                <br />
                <div className='line2'>
                    <p>Copyright © 2024 - EXPLERA VACATIONS CO., LTD</p>

                    <div className='social-acc'>
                        <Link to='https://www.facebook.com/explerathailand'>

                            <i class="bi bi-facebook"></i>
                        </Link>

                        <Link to='https://www.instagram.com/expleratha'>
                            <i class="bi bi-instagram"></i>
                        </Link>
                        <Link to='https://www.linkedin.com/company/explera-vacations-thailand-co-ltd/'>

                            <i class="bi bi-linkedin"></i>
                        </Link>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer